import {
    SIDEBAR_SUCCESS,
    RESET_SIDEBAR
  } from "../types";
  
  
  const initialState = {
    success: false,
    data: {}
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {		
      case SIDEBAR_SUCCESS:
        return {
          ...state,
            success: true,
                      data: action.payload
        };
          case RESET_SIDEBAR:
              return (state = initialState);
  
          default:
              return state;
      }
  };